import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::index
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:30
* @route '/admin/message-campaigns'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/message-campaigns',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::index
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:30
* @route '/admin/message-campaigns'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::index
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:30
* @route '/admin/message-campaigns'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::index
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:30
* @route '/admin/message-campaigns'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::index
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:30
* @route '/admin/message-campaigns'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::index
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:30
* @route '/admin/message-campaigns'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::index
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:30
* @route '/admin/message-campaigns'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::create
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:53
* @route '/admin/message-campaigns/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/admin/message-campaigns/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::create
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:53
* @route '/admin/message-campaigns/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::create
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:53
* @route '/admin/message-campaigns/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::create
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:53
* @route '/admin/message-campaigns/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::create
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:53
* @route '/admin/message-campaigns/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::create
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:53
* @route '/admin/message-campaigns/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::create
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:53
* @route '/admin/message-campaigns/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::store
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:108
* @route '/admin/message-campaigns'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/admin/message-campaigns',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::store
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:108
* @route '/admin/message-campaigns'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::store
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:108
* @route '/admin/message-campaigns'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::store
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:108
* @route '/admin/message-campaigns'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::store
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:108
* @route '/admin/message-campaigns'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::show
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:187
* @route '/admin/message-campaigns/{campaign}'
*/
export const show = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/admin/message-campaigns/{campaign}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::show
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:187
* @route '/admin/message-campaigns/{campaign}'
*/
show.url = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: args.campaign,
    }

    return show.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::show
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:187
* @route '/admin/message-campaigns/{campaign}'
*/
show.get = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::show
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:187
* @route '/admin/message-campaigns/{campaign}'
*/
show.head = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::show
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:187
* @route '/admin/message-campaigns/{campaign}'
*/
const showForm = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::show
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:187
* @route '/admin/message-campaigns/{campaign}'
*/
showForm.get = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::show
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:187
* @route '/admin/message-campaigns/{campaign}'
*/
showForm.head = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::start
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:206
* @route '/admin/message-campaigns/{campaign}/start'
*/
export const start = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: start.url(args, options),
    method: 'post',
})

start.definition = {
    methods: ["post"],
    url: '/admin/message-campaigns/{campaign}/start',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::start
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:206
* @route '/admin/message-campaigns/{campaign}/start'
*/
start.url = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: args.campaign,
    }

    return start.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::start
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:206
* @route '/admin/message-campaigns/{campaign}/start'
*/
start.post = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: start.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::start
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:206
* @route '/admin/message-campaigns/{campaign}/start'
*/
const startForm = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: start.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::start
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:206
* @route '/admin/message-campaigns/{campaign}/start'
*/
startForm.post = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: start.url(args, options),
    method: 'post',
})

start.form = startForm

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::pause
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:241
* @route '/admin/message-campaigns/{campaign}/pause'
*/
export const pause = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: pause.url(args, options),
    method: 'post',
})

pause.definition = {
    methods: ["post"],
    url: '/admin/message-campaigns/{campaign}/pause',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::pause
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:241
* @route '/admin/message-campaigns/{campaign}/pause'
*/
pause.url = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: args.campaign,
    }

    return pause.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::pause
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:241
* @route '/admin/message-campaigns/{campaign}/pause'
*/
pause.post = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: pause.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::pause
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:241
* @route '/admin/message-campaigns/{campaign}/pause'
*/
const pauseForm = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: pause.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::pause
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:241
* @route '/admin/message-campaigns/{campaign}/pause'
*/
pauseForm.post = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: pause.url(args, options),
    method: 'post',
})

pause.form = pauseForm

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::resume
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:259
* @route '/admin/message-campaigns/{campaign}/resume'
*/
export const resume = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resume.url(args, options),
    method: 'post',
})

resume.definition = {
    methods: ["post"],
    url: '/admin/message-campaigns/{campaign}/resume',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::resume
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:259
* @route '/admin/message-campaigns/{campaign}/resume'
*/
resume.url = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: args.campaign,
    }

    return resume.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::resume
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:259
* @route '/admin/message-campaigns/{campaign}/resume'
*/
resume.post = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resume.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::resume
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:259
* @route '/admin/message-campaigns/{campaign}/resume'
*/
const resumeForm = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resume.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::resume
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:259
* @route '/admin/message-campaigns/{campaign}/resume'
*/
resumeForm.post = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resume.url(args, options),
    method: 'post',
})

resume.form = resumeForm

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::destroy
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:277
* @route '/admin/message-campaigns/{campaign}'
*/
export const destroy = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin/message-campaigns/{campaign}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::destroy
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:277
* @route '/admin/message-campaigns/{campaign}'
*/
destroy.url = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: args.campaign,
    }

    return destroy.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::destroy
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:277
* @route '/admin/message-campaigns/{campaign}'
*/
destroy.delete = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::destroy
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:277
* @route '/admin/message-campaigns/{campaign}'
*/
const destroyForm = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\MessageCampaignsController::destroy
* @see app/Http/Controllers/Admin/MessageCampaignsController.php:277
* @route '/admin/message-campaigns/{campaign}'
*/
destroyForm.delete = (args: { campaign: string | number } | [campaign: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const messageCampaigns = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    start: Object.assign(start, start),
    pause: Object.assign(pause, pause),
    resume: Object.assign(resume, resume),
    destroy: Object.assign(destroy, destroy),
}

export default messageCampaigns